import { useCallback, useContext, memo } from 'react'

import ButtonSmall from '../../../components/display/Button/Small'

import { BookingItineraryContext } from './contexts/BookingItineraryContext'
import { isAdventureInItinerary } from '../utils'

const AddRemoveButton = ({
  adventureId,
  addText = 'Add',
  removeText = 'Remove',
  ...props
}) => {
  const {
    bookingAdventures,
    handleAddAdventureToBooking,
    handleRemoveAdventureFromBooking,
  } = useContext(BookingItineraryContext)

  const handleAdd = useCallback(
    () => handleAddAdventureToBooking(adventureId),
    [adventureId, handleAddAdventureToBooking],
  )

  const handleRemove = useCallback(
    () => handleRemoveAdventureFromBooking(adventureId),
    [adventureId, handleRemoveAdventureFromBooking],
  )

  return isAdventureInItinerary(bookingAdventures, adventureId) ? (
    <ButtonSmall onClick={handleRemove} ghost {...props} rounded>
      <span>{removeText}</span>
    </ButtonSmall>
  ) : (
    <ButtonSmall onClick={handleAdd} {...props} rounded>
      <span>{addText}</span>
    </ButtonSmall>
  )
}

export default memo(AddRemoveButton)
